import styled from 'styled-components';
import Image from '@stencil/image';

export const NoworNeverPersuationWrapper = styled.div(
  props => `
    display:flex;
    margin-top:${props.theme.spacing.base};
    flex-direction:${props.isRowAligned ? 'row' : 'column'};
    ${props.isDSD ? 'border:1px solid #FBE5DB;' : ''};
    border-radius:${props.theme.misc.borderRadius.xlarge};
    padding:${
      props.isRowAligned
        ? props.theme.spacing.custom(7)
        : props.isDSD
          ? props.theme.spacing.custom(8)
          : '0px'
    };
    margin:${props.theme.spacing.base} 0;
    ${props.isDSD ? 'background-color:#FBE5DB;' : ''};    
    padding-bottom:${props.isRowAligned ? '5px' : ''};
    justify-content:space-between;
    padding-bottom: 0px;
    margin-bottom: 0;
    padding-top: 7px;
    margin-top: 0px;
  `,
);

export const DealText = styled.p(
  props => `
    color:${props.tColor || props.theme.colors.goWhite.base};
    font-weight: bold;
    ${props.bigFont ? 'font-size: 14px; line-height: 18px;' : ''}
  `,
);

export const DealPara = styled.p(
  props => `
    display:flex;
    align-items:center;
    width:fit-content;
    background: ${
      props.ge && props.gs
        ? `linear-gradient(90deg,${props.gs} 0%,${props.ge} 266.8%)`
        : props.bgColor || ''
    };
    border-radius: ${props.isDSD ? '10px' : '40px'};
    ${
      props.isDSD
        ? `padding:${props.theme.spacing.custom(3)} ${
            props.isHeading ? props.theme.spacing.custom(6) : props.theme.spacing.custom(3)
          };`
        : props.isHeading
          ? 'padding:0.4rem 0.8rem'
          : ''
    };
    margin-bottom:3px;
    ${props.bdcColor ? `border:1px solid ${props.bdcColor}` : ''};
  `,
);

export const NoworNeverDetailReviewWrapper = styled.div(
  props => `
    background: ${
      !props.isDSD && props.ge && props.gs
        ? `linear-gradient(90deg,${props.gs} 0%,${props.ge} 266.8%)`
        : 'rgba(237, 126, 77, 0.2)'
    };    
    border-radius: ${props.isDSD ? '24px' : props.customStyle?.borderRadius || '12px'};
    justify-content:space-between;
    width:100%;
    display:flex;
    align-items: center;
    padding: ${
      props.isDSD
        ? `${props.theme.spacing.custom(4)} ${props.theme.spacing.custom(
            10,
          )} ${props.theme.spacing.custom(4)} ${props.theme.spacing.custom(4)}`
        : props.customStyle?.containerPadding || '8px 7px 8px 7px'
    };
    margin-bottom:10px;
  `,
);

export const NoworNeverTag = styled.div(
  props => `
    background: ${props.bgColor || ''};
    border-radius: 24px;
    display:flex;
    align-items: center;
    padding:${props.theme.spacing.custom(3)} ${
      props.isHeading ? props.theme.spacing.small : props.theme.spacing.custom(3)
    };
    ${!!props.middleSpan ? `flex:1; justify-content:flex-end` : ''}
  `,
);

export const FlexContainerWrap = styled.div(
  props => `
    display:flex
  `,
);

export const LMD_Image = styled(Image)(
  props => `
    width: ${props.isHeading ? '1rem' : '1.2rem'};
    height: ${props.isHeading ? '1.1rem' : '1.3rem'};
    margin:0 4px 0 0;
  `,
);
